import React from 'react';
import './FormField.css';

export default function FormField({
  label,
  optional = false,
  helperText = '',
  helperInline = false,
  unitHint = '',
  fullWidth = false,
  required = false,
  inputType = 'text',
  name,
  value,
  onChange,
  selectOptions = [],
  accept = '',
  fileSaved = false,
  step,
  rows = 3,
  placeholder = '',
}) {
  const id = name ? `field-${name}` : undefined;
  const labelContent = (
    <>
      {label}
      {required && ' *'}
      {unitHint && <span className="form-field-unit">{unitHint}</span>}
      {optional && <span className="form-field-optional"> (optional)</span>}
      {helperInline && helperText && <span className="form-field-helper-inline">{helperText}</span>}
    </>
  );

  const commonInputProps = {
    id,
    name,
    value: value ?? '',
    onChange,
    required,
    className: 'form-field-input',
  };

  let input;
  switch (inputType) {
    case 'textarea':
      input = <textarea {...commonInputProps} rows={rows} placeholder={placeholder} />;
      break;
    case 'select':
      input = (
        <select {...commonInputProps} value={value ?? ''}>
          <option value=""></option>
          {selectOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      );
      break;
    case 'file':
      input = (
        <>
          <input
            type="file"
            id={id}
            name={name}
            accept={accept}
            onChange={onChange}
            className="form-field-input"
          />
          {fileSaved && (
            <p className="form-field-file-note">
              {typeof fileSaved === 'string' ? `Current file: ${fileSaved}` : 'Current file saved'}
            </p>
          )}
        </>
      );
      break;
    case 'number':
      input = (
        <input
          type="number"
          {...commonInputProps}
          value={value === null || value === undefined ? '' : value}
          step={step}
          placeholder={placeholder}
        />
      );
      break;
    default:
      input = (
        <input
          type={inputType}
          {...commonInputProps}
          placeholder={placeholder}
        />
      );
  }

  return (
    <div className={`form-field ${fullWidth ? 'form-field-full' : ''}`}>
      <label htmlFor={id} className="form-field-label">
        {labelContent}
      </label>
      {helperText && !helperInline && <p className="form-field-helper">{helperText}</p>}
      {input}
    </div>
  );
}
